import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAuth } from "../../../store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../store/store";
import { LOGOUT_BROADCAST_KEY } from "../../../utilities/Tools";

interface LogoutButtonProps {
  isLoggingOut(): void;
}

const URL = "url";

const LogoutButton = (props: LogoutButtonProps) => {
  const auth = useSelector((state: RootState) => state.root.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    props.isLoggingOut();
    const url = localStorage.getItem(URL);
    fetch(url + "/partsapp/auth/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: auth.token,
      },
    }).finally(() => {
      localStorage.setItem(LOGOUT_BROADCAST_KEY, auth.id);
      dispatch(clearAuth());
      navigate("/login", { replace: true });
    });
  };

  return (
    <button
      id="home-header-logout-button"
      className="home-header-hamburger-button"
      onClick={logout}
    >
      Logout
    </button>
  );
};

export default LogoutButton;
